export default "__VITE_ASSET__DdGATlQo__"